import { onMounted as d, onBeforeUnmount as c } from "vue";
import { getEventCode as s } from "./index589.js";
import { EVENT_CODE as f } from "./index590.js";
import { isClient as n } from "./index599.js";
let e = [];
const r = (o) => {
  s(o) === f.esc && e.forEach(
    (i) => i(o)
  );
}, l = (o) => {
  d(() => {
    e.length === 0 && document.addEventListener("keydown", r), n && e.push(o);
  }), c(() => {
    e = e.filter(
      (t) => t !== o
    ), e.length === 0 && n && document.removeEventListener("keydown", r);
  });
};
export {
  l as useEscapeKeydown
};
